import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { CustomerStatus } from "@saleor/types/globalTypes";
import {
  createDateField,
  createNumberField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CustomerFilterKeys {
  customerStatus = "customerStatus",
  joined = "joined",
  moneySpent = "spent",
  numberOfOrders = "orders"
}

export interface CustomerListFilterOpts {
  customerStatus: FilterOpts<CustomerStatus[]>;
  joined: FilterOpts<MinMax>;
  moneySpent: FilterOpts<MinMax>;
  numberOfOrders: FilterOpts<MinMax>;
}

const messages = defineMessages({
  customerType: {
    defaultMessage: "Customer Type",
    description: "customer type"
  },
  existing: {
    defaultMessage: "Existing",
    description: "existing customer"
  },
  joinDate: {
    defaultMessage: "Join Date",
    description: "customer"
  },
  moneySpent: {
    defaultMessage: "Money Spent",
    description: "customer"
  },
  new: {
    defaultMessage: "New",
    description: "new customer"
  },
  numberOfOrders: {
    defaultMessage: "Number of Orders"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CustomerListFilterOpts
): IFilter<CustomerFilterKeys> {
  return [
    {
      ...createOptionsField(
        CustomerFilterKeys.customerStatus,
        intl.formatMessage(messages.customerType),
        opts.customerStatus.value,
        false,
        [
          {
            label: intl.formatMessage(messages.existing),
            value: CustomerStatus.ACT
          },
          {
            label: intl.formatMessage(messages.new),
            value: CustomerStatus.NEW
          }
        ]
      ),
      active: opts.customerStatus.active
    },
    {
      ...createDateField(
        CustomerFilterKeys.joined,
        intl.formatMessage(messages.joinDate),
        opts.joined.value
      ),
      active: opts.joined.active
    },
    {
      ...createNumberField(
        CustomerFilterKeys.moneySpent,
        intl.formatMessage(messages.moneySpent),
        opts.moneySpent.value
      ),
      active: opts.moneySpent.active
    },
    {
      ...createNumberField(
        CustomerFilterKeys.numberOfOrders,
        intl.formatMessage(messages.numberOfOrders),
        opts.numberOfOrders.value
      ),
      active: opts.numberOfOrders.active
    }
  ];
}
